
export const iState = {
  imageURL: false,
  originalImageURL: false,
  chosenRadiance: false,
  useDefaultPhoto: false
}

export const state = {
  get imageURL () {
    var mem = iState.imageURL
    if (!mem) {
      let sessionImage = window.sessionStorage.getItem('photo-store/imageURL')
      iState.imageURL = sessionImage
      return sessionImage
    }
    return mem
  },
  set imageURL (v) {
    iState.imageURL = v
    window.sessionStorage.setItem('photo-store/imageURL', v)
  },
  get chosenRadiance () {
    let chosenRadiance = window.sessionStorage.getItem('photo-store/chosenRadiance')
    iState.chosenRadiance = JSON.parse(chosenRadiance)
    return iState.chosenRadiance
  },
  set chosenRadiance (v) {
    iState.chosenRadiance = JSON.stringify(v)
    window.sessionStorage.setItem('photo-store/chosenRadiance', iState.chosenRadiance)
  },
  get useDefaultPhoto () {
    var mem = iState.useDefaultPhoto
    if (!mem) {
      let useDefaultPhoto = window.sessionStorage.getItem('photo-store/useDefaultPhoto')
      iState.useDefaultPhoto = JSON.parse(useDefaultPhoto)
      return iState.useDefaultPhoto
    }
    return mem
  },
  set useDefaultPhoto (v) {
    iState.useDefaultPhoto = JSON.stringify(v)
    window.sessionStorage.setItem('photo-store/useDefaultPhoto', iState.useDefaultPhoto)
  },
  get formData () {
    let formData = window.sessionStorage.getItem('photo-store/formData')
    try {
      return JSON.parse(formData)
    } catch (e) {
      console.log(e)
      return false
    }
  },
  set formData (v) {
    iState.formData = JSON.stringify(v)
    window.sessionStorage.setItem('photo-store/formData', iState.formData)
  },
  get originalImageURL () {
    var mem = iState.originalImageURL
    if (!mem) {
      let sessionImage = window.sessionStorage.getItem('photo-store/originalImageURL')
      iState.originalImageURL = sessionImage
      return sessionImage
    }
    return mem
  },
  set originalImageURL (v) {
    iState.originalImageURL = v
    window.sessionStorage.setItem('photo-store/originalImageURL', v)
  }
}



// WEBPACK FOOTER //
// ./src/components/DOM/PhotoStore/PhotoStore.js